import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TCorePage, TStatusExtraData } from "../../Types";
import { post } from "../axios-post";

export const apiCallChangeUserStatus = async ({
  userUUID,
  userStatus,
  pageName,
  extraData
}: {
  userUUID: string;
  userStatus: string;
  pageName: TCorePage;
  extraData: TStatusExtraData;
}): Promise<{
  data: string;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{ userStatus: string }>(
    `user/changeStatus`,
    {
      userUUID,
      status: userStatus,
      pageName,
      extraData
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.userStatus,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (
    status === "ERROR" &&
    isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      et3Error
    )
  ) {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
